module.exports = __webpack_public_path__ + "static/media/george_app_footer_logo.7ca3ebab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/george_app_footer_logo.svg
// module id = 160
// module chunks = 21